import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    templateUrl: 'know-more-about-master-preferred-ratings.component.html',
    styleUrls: ['../../../assets/styles/finzy-styles.scss', './know-more-about-master-preferred-ratings.component.scss']
})
export class KnowMoreAboutMasterPreferredRatingsComponent {
    public readonly matDialogRef: MatDialogRef<KnowMoreAboutMasterPreferredRatingsComponent>;

    constructor(matDialogRef: MatDialogRef<KnowMoreAboutMasterPreferredRatingsComponent>) {
        this.matDialogRef = matDialogRef;
    }
}